import {useMemo, useState} from "react";
import {ProductionVolumeEntity} from "@ots-frontend/ots-data";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";
import {useDebouncedValue} from "@mantine/hooks";

export type UseProductionVolumeDataTableFilterProps = Omit<UseDataTableFilterProps<ProductionVolumeEntity>, 'filterConfig'>

export function useProductionVolumeDataTableFilter(props: UseProductionVolumeDataTableFilterProps): UseDataTableFilterResult<ProductionVolumeEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const [objectQuery, setObjectQuery] = useState<string | undefined>(undefined);
  const [objectDebouncedQuery] = useDebouncedValue(objectQuery, 200);

  const [freightTypeQuery, setFreightTypeQuery] = useState<string | undefined>(undefined);
  const [freightTypeDebouncedQuery] = useDebouncedValue(freightTypeQuery, 200);

  const filterConfig: DataTableFilterConfig<ProductionVolumeEntity> = useMemo(() => {
    return {
      "object": {
        setQuery: setObjectQuery,
        query: objectQuery,
        debouncedQuery: objectDebouncedQuery,
        filter: (record, query) => !record.objectName || !record.objectName.toLowerCase().includes(query.toLowerCase())
      },
      "freightType": {
        setQuery: setFreightTypeQuery,
        query: freightTypeQuery,
        debouncedQuery: freightTypeDebouncedQuery,
        filter: (record, query) => !record.freightTypeName || !record.freightTypeName.toLowerCase().includes(query.toLowerCase())
      },
    }
  }, [
    objectQuery,
    objectDebouncedQuery,
    freightTypeQuery,
    freightTypeDebouncedQuery,
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
